import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    portalUsers: [],
    pagination: {},
    selectedPortalUser: null,
    isLoading: false
};

const portalUserSlice = createSlice({
    name: "portalUser",
    initialState,
    reducers: {
        setPortalUsers: (state, action) => {
            state.portalUsers = action.payload;
        },

        setPagination: (state, action) => {
            state.pagination = action.payload;
        },

        setSelectedPortalUser: (state, action) => {
            state.selectedPortalUser = action.payload;
        },

        removePortalUser: (state, action) => {
            state.portalUsers = state.portalUsers.filter(
                user => user._id !== action.payload
            );
        },

        setLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    }
});

export const {
    setPortalUsers,
    setPagination,
    setSelectedPortalUser,
    removePortalUser,
    setLoading
} = portalUserSlice.actions;

export const PortalUserReducer = portalUserSlice.reducer;